/*
 * Build env snapshot tab: pure model, no React. Only fingerprints are ever shown (never a value), so the helpers here
 * work on fingerprints, counts and key/visibility pairs.
 */
import type { EnvSnapshot } from '@/api/schemas';

export type SnapshotEntry = EnvSnapshot['entries'][number];

/** How many entries are secrets (the header counts them next to the total). */
export const secretCount = (entries: Pick<SnapshotEntry, 'visibility'>[]): number => entries.filter((e) => e.visibility === 'secret').length;

/** The source line of an entry: where it came from, plus its type when it is not a plain string. */
export const sourceText = (e: Pick<SnapshotEntry, 'source' | 'valueType'>): string => `${e.source}${e.valueType !== 'string' ? ` · ${e.valueType}` : ''}`;

/** The variables a trigger overrode, as `KEY (visibility, fingerprint)` joined by dots. */
export const overridesText = (overrides: EnvSnapshot['overrides']): string => overrides.map((o) => `${o.key} (${o.visibility}, ${o.valueFingerprint})`).join(' · ');
